import script from "./LanguageSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelect.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelect.vue?vue&type=style&index=0&id=c1162b94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1162b94"]])

export default __exports__